import type { ProductSnapshot } from './types';

export interface ProductFilters {
  keyword?: string;
  categoryId?: number;
  brandId?: number;
  status?: number;
  priceMinYuan?: number | null;
  priceMaxYuan?: number | null;
  originalPriceMinYuan?: number | null;
  originalPriceMaxYuan?: number | null;
}

export function matchesProductFilters(item: ProductSnapshot, f: ProductFilters): boolean {
  if (f.keyword) {
    const kw = f.keyword.trim().toLowerCase();
    if (kw && !item.name.toLowerCase().includes(kw) && !item.productCode.toLowerCase().includes(kw))
      return false;
  }
  if (f.categoryId != null && item.categoryId !== f.categoryId) return false;
  if (f.brandId != null && item.brandId !== f.brandId) return false;
  if (f.status != null && item.status !== f.status) return false;
  if (f.priceMinYuan != null && item.priceCents < Math.round(f.priceMinYuan * 100)) return false;
  if (f.priceMaxYuan != null && item.priceCents > Math.round(f.priceMaxYuan * 100)) return false;
  if (f.originalPriceMinYuan != null && item.originalPriceCents != null
      && item.originalPriceCents < Math.round(f.originalPriceMinYuan * 100)) return false;
  if (f.originalPriceMaxYuan != null && item.originalPriceCents != null
      && item.originalPriceCents > Math.round(f.originalPriceMaxYuan * 100)) return false;
  return true;
}
